import {
  getData,
  postData,
  getPromise 
} from './api-base.service'


export const getStudent = (studentId) => {
  let result = getData('/Student/Get', {
    studentId: studentId
  });
  return result;
}

export const getStudentMemberInfo = (studentId, phone = "", includeCourseFreeVideoCount = true) => {
  let data = {
    studentId: studentId,
    phone: phone,
    includeCourseFreeVideoCount: includeCourseFreeVideoCount
  };
  let result = getData('/Student/MemberInfo', data);
  return result;
}

export const getStudentVideoDurationSettings = (studentId) => {
  let data = {
    studentId: studentId
  };
  return getData("/Student/GetStudentVideoDurationSettings", data);
}


// WEBPACK FOOTER //
// ./src/service/student.service.js